import {
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Flex,
  Text,
  Portal,
  chakra,
} from '@chakra-ui/react'
import { GrLanguage } from 'react-icons/gr'
import type { FC } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { languages } from '../../utils/constants'

// 👇 On force GrLanguage à être un FC valide pour Chakra
const ChakraGrLanguage = chakra(GrLanguage as FC)

const LanguageButton = ({ color }: { color: string }) => {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const changeLanguage = async (lng: string) => {
    await i18n.changeLanguage(lng)
    setIsOpen(false)
    // Force re-render by reloading translations
    window.location.reload()
  }

  return (
    <Menu
      placement="right-end"
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    >
      <MenuButton
        as={IconButton}
        aria-label="Language selector"
        icon={<ChakraGrLanguage boxSize={5} />}
        w="48px"
        h="48px"
        borderRadius="md"
        bg="transparent"
        border="2px solid"
        borderColor={color}
        _hover={{
          bg: 'transparent',
          borderColor: 'brand.purple',
        }}
        _active={{
          bg: 'transparent',
          borderColor: 'brand.purple',
        }}
        color={color}
        sx={{
          svg: {
            color: color,
            '& path': {
              stroke: color,
            },
          },
          '&:hover': {
            '& svg': {
              color: 'brand.purple',
            },
            '& svg path': {
              stroke: 'brand.purple',
            },
          },
          '&[data-active]': {
            '& svg': {
              color: 'brand.purple',
            },
            '& svg path': {
              stroke: 'brand.purple',
            },
          },
        }}
      />
      <Portal>
        <MenuList
          color="brand.sideBarBlack"
          bg="white"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="lg"
          zIndex={9999}
          minW="150px"
        >
          {languages.map(({ code, flag, name }) => (
            <MenuItem
              key={code}
              onClick={() => changeLanguage(code)}
              _hover={{ bg: 'purple.50' }}
            >
              <Flex align="center">
                <Text fontSize="md" mr={4}>
                  {flag}
                </Text>
                <Text fontSize="md">{name}</Text>
              </Flex>
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  )
}

export default LanguageButton